import axios from 'axios';
import { getApiHeaders } from '../../../utils/apiHelpers';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/pulizie`;

export const pulizieApi = {
  get: (path, opts = {}) => axios.get(`${BASE}${path}`, { headers: getApiHeaders(), ...opts }).then((r) => r.data),
  post: (path, body) => axios.post(`${BASE}${path}`, body, { headers: getApiHeaders() }).then((r) => r.data),
  put: (path, body) => axios.put(`${BASE}${path}`, body, { headers: getApiHeaders() }).then((r) => r.data),
  del: (path) => axios.delete(`${BASE}${path}`, { headers: getApiHeaders() }).then((r) => r.data),
};

export const erroreApi = (e, fallback) => e?.response?.data?.detail || fallback;

export const meseCorrente = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

export const dataBreve = (iso) =>
  new Date(`${iso}T12:00:00`).toLocaleDateString('it-IT', { weekday: 'short', day: 'numeric', month: 'short' });
